import { handleLocalStorage } from '@utils';
import { LocalStorageKeys } from '@utils/types';

import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

const { removeItem } = handleLocalStorage;

export const removeKeysLocalStorage: TMiddleware = () => next => action => {
  const { scheme, i18nextLng } = LocalStorageKeys;
  const ignoreKeys = [scheme, i18nextLng];

  if (checkActionsType(action, [loginActions.logout.fulfilled])) {
    Object.values(LocalStorageKeys)
      .filter(key => !ignoreKeys.includes(key))
      .forEach(key => removeItem(key));
  }
  return next(action);
};

export default removeKeysLocalStorage;
